// test1820
(1820 && 0);
